module.exports = __webpack_public_path__ + "img/electronic_reserved.6808af29.svg";